import axios from "axios";
import React, {Component} from "react";
import CategoryForm from "../components/CategoryForm";
import Loading from "../components/Loading";
import PageNav from "../partials/PageNav";

class   Category extends Component{

    state = {
        isModal : false,
        formData : null,
        categories : [],
        loading : false,
    }

    componentDidMount(){
        this.getCategories();
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    async getCategories(){
        this.setState({
            loading : false
        })
        var categories = await axios.get('categories');
        if(categories.status === 200)
        {
            this.setState({categories : categories.data, loading : true})
        }
    }

    showModal = (category = {}) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : category,
        })
        this.getCategories()
    }

    delete = (category) =>{
        axios.delete("categories/" + category).then((response) => {
            this.getCategories()
        }).catch((error)=>{})
    }

    handleCheck(val) {
        var permissions = JSON.parse(localStorage.getItem("permissions")) ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some(item => val === item.name)
    }

    render(){
        let pageNav = PageNav("liste et paramètrage  des catégories", "/categories",  "/logo192.png",  "Catégories",  "Liste de nos catégories");
        var user = localStorage.getItem("user") ?  JSON.parse(localStorage.getItem("user")) : {};
        var count =1, categories =
        this.state.categories.map((category) => {
            return(
                <tr key={category.id}>
                    <td>{count++}</td>
                    <td><i className={ category.icone}></i> { category.name } </td>
                    <td>{ category.category != null ? category.category.name : "" }</td>
                    {/* <td><span  className="text-truncate">{ category.description }</span></td> */}
                    <td>{ category.user != null ? <span><img src={category.user.avatar} className="rounded-circle thumb-sm border border-2" style={{  width : 50 }} />{ category.user.name}</span> : "" }</td>
                    <td className="text-end">
                        {
                            (this.handleCheck("modifier categorie") == true && user.id == category.user.id ) && (
                        <a href="#" onClick={ () => this.showModal(category)}><i className="bi bi-pen text-primary font-22 me-3" ></i></a>
                        )}
                        {
                        (this.handleCheck("supprimer categorie") == true && user.id == category.user.id ) && (
                            <a href="#" onClick={() => this.delete(category.id)}><i className="bi bi-trash text-danger font-22"></i></a>
                        )}
                    </td>
                </tr>
            )
        })
        return(
            <main id="main">
                  { pageNav }
                <div className="container">
                  <div className="row col-sm-12">
                      <div className="page-title-box">
                            
                              {
                                  this.handleCheck("ajouter categorie") == true && (
                                      <div className="btn-toolbar mb-2 mb-md-0 d-end float-end">
                                          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showModal(null)}><i className="bi bi-plus font-18"></i> Nouvelle catégorie</button>
                                      </div>
                                  )
                              }
                      </div>
                      {
                          !this.state.loading && (<Loading /> )
                      }
                </div>
                <div className="col-12">
                    <div className="card shadow bg-white mb-2">
                        <div className="card-header">
                            <h4 className="card-titl">Liste des catégories</h4>
                            <p className="text-muted mb-0">
                                <small>Effectuer plus des opérations sur les catégories</small>
                            </p>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Catégorie</th>
                                            <th>Grande catégorie</th>
                                            {/* <th>Description</th> */}
                                            <th>Actionnaire</th>
                                            <th className="text-end">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { categories }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

              </div>

              <CategoryForm
                isModal={this.state.isModal}
                formData={this.state.formData}
                showModal={this.showModal}
            />

        </main>
        )
    }
}
export default Category;
